import { Link } from 'react-router-dom';

import { IcpFooter } from '../components/IcpFooter';
import { CopyrightDocument } from '../components/CopyrightDocument';
import { PrivacyPolicyDocument } from '../components/PrivacyPolicyDocument';
import { SupportDocument } from '../components/SupportDocument';
import { TermsOfServiceDocument } from '../components/TermsOfServiceDocument';
import { appConfig } from '../config/appConfig';

function LegalPageShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col bg-canvas">
      <header className="border-b border-border bg-surface px-4 py-3">
        <div className="mx-auto flex max-w-3xl items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2 text-sm font-semibold text-ink hover:text-primary">
            <img src="/icon_main.png" alt="" className="h-8 w-8 rounded-lg" />
            {appConfig.appName}
          </Link>
          <Link to="/login" className="text-sm font-medium text-primary hover:underline">
            登录
          </Link>
        </div>
      </header>
      <main className="mx-auto w-full max-w-3xl flex-1 px-4 py-10 sm:px-6">
        {children}
      </main>
      <IcpFooter />
    </div>
  );
}

export function PrivacyPage() {
  return (
    <LegalPageShell>
      <PrivacyPolicyDocument />
    </LegalPageShell>
  );
}

export function CopyrightPage() {
  return (
    <LegalPageShell>
      <CopyrightDocument />
    </LegalPageShell>
  );
}

export function SupportPage() {
  return (
    <LegalPageShell>
      <SupportDocument />
    </LegalPageShell>
  );
}

export function TermsPage() {
  return (
    <LegalPageShell>
      <TermsOfServiceDocument />
    </LegalPageShell>
  );
}

export function AboutPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-ink">关于颗粒日记</h1>
        <p className="mt-2 text-muted">Web 主站与 Mobile App 共享同一 AppFunctor / AppWorker 后端。</p>
      </div>

      <div className="space-y-2 text-sm text-muted">
        <p>网站备案：{appConfig.icpWebsite}</p>
        <p>App 备案：京ICP备2026007820号-2A</p>
      </div>

      <div className="flex flex-wrap gap-3">
        <Link
          to="/privacy"
          className="rounded-lg border border-border px-4 py-3 text-sm font-medium text-ink hover:bg-canvas"
        >
          隐私政策
        </Link>
        <Link
          to="/terms"
          className="rounded-lg border border-border px-4 py-3 text-sm font-medium text-ink hover:bg-canvas"
        >
          用户协议
        </Link>
        <Link
          to="/copyright"
          className="rounded-lg border border-border px-4 py-3 text-sm font-medium text-ink hover:bg-canvas"
        >
          版权声明
        </Link>
        <Link
          to="/support"
          className="rounded-lg border border-border px-4 py-3 text-sm font-medium text-ink hover:bg-canvas"
        >
          联系我们
        </Link>
        <Link
          to="/download?view=1"
          className="rounded-lg border border-border px-4 py-3 text-sm font-medium text-ink hover:bg-canvas"
        >
          下载 App
        </Link>
        <a
          href="https://kelilearning.com/download"
          className="rounded-lg border border-border px-4 py-3 text-sm font-medium text-ink hover:bg-canvas"
        >
          官网扫码下载
        </a>
        <Link
          to="/feedback"
          className="rounded-lg border border-border px-4 py-3 text-sm font-medium text-ink hover:bg-canvas"
        >
          应用内反馈
        </Link>
      </div>
    </div>
  );
}
